import React, { useState, DragEvent, ChangeEvent } from "react";

export default function UploadExcel() {
    const [files, setFiles] = useState<File[]>([]);

    const handleSelect = (e: ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files) return;
        setFiles(Array.from(e.target.files));
    };

    const handleDrop = (e: DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        if (!e.dataTransfer.files) return;
        setFiles(Array.from(e.dataTransfer.files));
    };

    const handleDragOver = (e: DragEvent<HTMLDivElement>) => {
        e.preventDefault();
    };

    const handleUpload = () => {
        if (files.length === 0) {
            alert("Vui lòng chọn file trước");
            return;
        }
        console.log("Uploading files:", files);
        alert("Upload demo – bạn nối API tại đây");
    };

    return (
        <div className="styles_content_container__EZh4M">
            <div className="styles_container__1hcxY">
                <p className="MuiTypography-root styles_title_text__C6AEC MuiTypography-body1">
                    Chọn file từ máy tính của bạn (.xls hoặc xlsx) để thêm sản phẩm hàng loạt
                </p>

                <div className="styles_uploading_container__3Eeny">
                    <div className="styles_btn_upload_file__TsxM8">
                        <section>
                            <div
                                tabIndex={0}
                                className="styles_file_name__gFbfe"
                                onDrop={handleDrop}
                                onDragOver={handleDragOver}
                            >
                                <input
                                    type="file"
                                    multiple
                                    autoComplete="off"
                                    tabIndex={-1}
                                    style={{ display: "none" }}
                                />

                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: 43 }}>
                                    <span style={{ position: "relative" }}>
                                        <img
                                            src="https://cdn-web-next.thuocsi.vn/images/icon/add_file.png"
                                            alt=""
                                        />
                                    </span>

                                    <p
                                        className="MuiTypography-root MuiTypography-body1"
                                        style={{ marginLeft: 14, fontSize: 12, fontFamily: "ggsr" }}
                                    >
                                        Kéo thả file vào đây
                                    </p>
                                </div>
                            </div>
                        </section>

                        <label htmlFor="contained-button-file">
                            <input
                                id="contained-button-file"
                                type="file"
                                multiple
                                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                className="styles_input__Iv0Z5"
                                onChange={handleSelect}
                            />

                            <span className="MuiButtonBase-root MuiButton-root MuiButton-text styles_btn_choose_file__z8ysM" role="button">
                                <span className="MuiButton-label">Chọn file...</span>
                            </span>
                        </label>
                    </div>

                    <button
                        type="button"
                        className="MuiButtonBase-root MuiButton-root MuiButton-text styles_btn_upload__tyyLp"
                        onClick={handleUpload}
                    >
                        <span className="MuiButton-label">Đăng tải</span>
                    </button>
                </div>

                {files.length > 0 && (
                    <div style={{ marginTop: 12, fontSize: 13 }}>
                        <b>File đã chọn:</b> {files.map(f => f.name).join(", ")}
                    </div>
                )}

                <div className="MuiGrid-root styles_note_upload_text__jljnU MuiGrid-container MuiGrid-direction-xs-column">
                    <div
                        className="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-content-xs-space-between"
                        style={{ width: 85, cursor: "pointer" }}
                    >
                        <p className="MuiTypography-root styles_text_sample_file__4a6dC MuiTypography-body1">File mẫu</p>

                        <svg className="MuiSvgIcon-root" viewBox="0 0 24 24">
                            <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z" />
                        </svg>
                    </div>

                    <p
                        className="MuiTypography-root MuiTypography-body1"
                        style={{ fontFamily: "ggsr", fontWeight: 500, fontSize: 16 }}
                    >
                        Chú ý:
                    </p>

                    <ul className="ctrl-ul">
                        <li>Chỉ đăng tải file excel (đuôi .xlsx)</li>
                        <li>Dung lượng file tối đa 5mb</li>
                        <li>
                            Điền đầy đủ <b>SKU, Tên sản phẩm, Số lượng, Đơn giá (vnđ)</b> để tránh trường hợp sản phẩm bị lỗi khi đăng tải
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}
